var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"bolsasEdescontos"}},[_c('Banner',{attrs:{"nomePagina":"Bolsas e Descontos"}}),_c('Apoio'),_c('Condicoes'),_c('Candidatar'),_c('Prouni'),_c('Duvidas'),_c('BoaBolsa')],1)}
var staticRenderFns = []

export { render, staticRenderFns }